export interface SiteLogoStateInterface {
  logoFileHref?: string;
}

export class SiteLogoState implements SiteLogoStateInterface {
  public logoFileHref?: string;

  constructor({
    logoFileHref = undefined,
  }: SiteLogoStateInterface) {
    this.logoFileHref = logoFileHref;
  }
}
